
/**
 * This module increases the height of the text areas.
 */
export default function openTextAreas() {
	const textareas = document.querySelectorAll( '.textarea' );

	if ( !textareas ) {
		return;
	}

	Array.from( textareas ).forEach( function doActions( element ) {
		addTextareaListener( element );
		checkIfFilled( element );
	});

	/**
	 * Adds the on focus listener.
	 *
	 * @param {object} element the checkbox element
	 */
	function addTextareaListener( element ) {
		element.addEventListener( 'focus', function activate() {
			element.classList.add( 'active' );
		});
	}

	/**
	 * Checks it the textarea has text. (When completing the form).
	 *
	 * @param {object} element the checkbox element
	 */
	function checkIfFilled( element ) {
		if ( element.value ) {
			element.classList.add( 'active' );
		}
	}
}
